import React from "react";
import { Link } from "react-router-dom";

export function Logo({ variant = "dark", showText = true, className = "" }) {
  const textColor = variant === "light" ? "text-white" : "text-navy";
  return (
    <Link to="/" className={`flex items-center gap-3 group ${className}`} data-testid="afha-logo">
      <img
        src="/afha-logo.png"
        alt="AFHA — American Family Health Association"
        className="h-11 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]"
      />
      {showText && (
        <span className={`hidden sm:flex flex-col leading-none ${textColor}`}>
          <span className="font-display font-black text-lg tracking-tight">AFHA</span>
          <span className={`text-[10px] tracking-[0.18em] uppercase ${variant === "light" ? "text-white/70" : "text-muted-foreground"}`}>
            Health Association
          </span>
        </span>
      )}
    </Link>
  );
}
